import React from 'react';
import axios from 'axios';

import { useState, useRef } from 'react';
import { apiUrl } from '..';

import { useAlert } from "react-alert";

const ReportBar = (Props) => {
    const alert = useAlert();
    
    var reportBar = useRef(null);

    const {nodeType, QnA, content} = Props;
    const [reportLoading, setReportLoading] = useState(false);

    function report(type){
        if(!reportLoading){
            setReportLoading(true);
            axios({
                method: 'post',
                url: `${apiUrl}/submit_report`,
                data: {
                    type: type,
                    nodeType: nodeType,
                    content: content,
                    QnA: QnA
                }

            }).then((response) => {
                setReportLoading(false);
                alert.success("Report submitted successfully");
                console.log(response.data);
                reportBar.current.style.display = "none";
            }).catch((error) => {
                if(error.response.data.error){
                alert.error(error.response.data.error);
                } else {
                alert.error("An error occurred while trying to generate recommendations.");
                }
                setReportLoading(false);
                //console.log(error);
            });
        }
    }
    //>
    return (
        <div className='reportBar' ref={reportBar}> 
            <button className='reportButton good' onClick={() => report("good")}><i className="fa-solid fa-thumbs-up" /></button>
            <button className='reportButton bad' onClick={() => report("bad")}><i className="fa-solid fa-flag" /></button>
        </div>
    );
};

export default ReportBar;